<app-championtv
  [championsTv]="(championsTv$ | async)!"
  (filterChange)="onFilterChange($event)"
  [loading]="!!(loading$ | async)"
  [theme]="theme"
  [month]="month"
  [minHeight]="minHeight"
></app-championtv>
